export default __webpack_public_path__ + "static/media/Prologue_Aurora1.5c78254f.svg";